@if (messageInputController().hasError('maxlength')) {
  <div class="error-wrapper">
    <orbit-message
      [message]="
        'SHARED.CONVERSATION_FOOTER.ERROR_MESSAGE'
          | translate
            : {
                maxChars: messageInputController().errors?.['maxlength']?.requiredLength,
                yourChars: messageInputController().errors?.['maxlength']?.actualLength,
              }
      "
      [title]="'SHARED.CONVERSATION_FOOTER.TITLE' | translate"
      [severity]="'error'" />
  </div>
}

@if (isConversationLocked()) {
  <!-- CONVERSATIOM LOCKED -->
  <div class="info-message" data-testid="conversation-locked-message">
    <span class="message-text">
      {{ conversationLockNote() | translate }}
    </span>
    <orbit-button
      [icon]="unlockIcon"
      [size]="'large'"
      (click)="unlockAction.emit(conversationId())"
      (keydown)="onUnlockKeyDown($event)" />
  </div>
} @else if (isConversationArchived()) {
  <!-- CONVERSATION ARCHIVED -->
  <div class="info-message" data-testid="conversation-archived-message">
    <span class="message-text">
      {{ 'SHARED.CONVERSATION_FOOTER.ARCHIVED_NOTE' | translate }}
    </span>
  </div>
} @else if (userId() && noUsers()) {
  <!-- NO USERS -->
  <div class="info-message" data-testid="conversation-no-users-message">
    <span class="message-text">
      {{ 'SHARED.PARTICIPANT_LIST.NO_USERS' | translate }}
    </span>
    <orbit-button
      [icon]="joinIcon"
      [size]="'small'"
      [testId]="'btn-conversation-footer-join'"
      (click)="joinConversation.emit()"
      (keydown)="onJoinConversationKeyDown($event)"
      [label]="'SHARED.PARTICIPANT_LIST.JOIN' | translate" />
  </div>
} @else if (userId() && userIsNotParticipant()) {
  <!-- LOGGED IN USER IS NOT A PARTICIPANT -->
  <div class="info-message" data-testid="conversation-not-participant-message">
    <span class="message-text">
      {{ 'SHARED.PARTICIPANT_LIST.ADD_YOURSELF' | translate }}
    </span>
    <orbit-button
      [icon]="joinIcon"
      [size]="'small'"
      [testId]="'btn-conversation-footer-join'"
      (click)="joinConversation.emit()"
      (keydown)="onJoinConversationKeyDown($event)"
      [label]="'SHARED.PARTICIPANT_LIST.JOIN' | translate" />
  </div>
} @else {
  @if (conversationId()) {
    <div class="input-bar">
      <orbit-input
        inputType="textarea"
        class="input"
        inputId="message-input"
        [ariaLabel]="messageInputAriaLabel()"
        rounded
        [testId]="'conversation-footer-input'"
        [addonLeft]="{
          button: true,
          flat: true,
          testId: 'btn-show-addon-bar',
          icon: addonButtonIcon(),
          disabled: messageInputController().invalid || loading(),
          ariaLabel: ('SHARED.CONVERSATION_FOOTER.ADDON_TOGGLE_LABEL' | translate),
        }"
        [preventTyping]="loading()"
        [loading]="loading()"
        [placeholder]="'SHARED.CONVERSATION_FOOTER.PLACEHOLDER' | translate"
        [controller]="messageInputController()"
        (addonButtonClicked)="toggleFooterAddon()"
        (enterPressed)="
          !messageInputController().invalid && !loading() ? sendMessageHandler($event) : null
        "
        (deleteAttachmentEvent)="handleDeleteAttachment($event)"
        [inputSourceId]="nextMessageSourceId()"
        [(files)]="files"
        (isTyping)="isTyping.emit($event)" />
      <orbit-button
        [styleClass]="addonButtonStyle()"
        rounded
        [testId]="'btn-send-message'"
        [icon]="sendIcon"
        [ariaLabel]="'SHARED.CONVERSATION_FOOTER.SEND_BUTTON_LABEL' | translate"
        [disabled]="messageInputController().invalid || loading()"
        (buttonClick)="sendMessageHandler(true)"
        (keydown)="onSendMessageKeyDown($event)" />
    </div>
  }
}
@if (addonBarVisible()) {
  <shared-footer-addon
    [senderType]="senderType()"
    [templates]="templates()"
    (buttonClick)="handleAddonClick($event)"
    [(files)]="files"
    [deletedAttachment]="deletedAttachment()" />
}
